// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Pg0g","requiredAsterisk":"Info_requiredAsterisk__104fI"};